if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

var lastScrollTop = 0;

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    // SLIDERS
    $('.sym-slides').slick({
        accessibility: true,
        arrows: false,
        dots: false,
        autoplay: true, 
        fade: true,
        accessibility: false,
        pauseOnHover: false,
        autoplaySpeed: 5000,
        speed: 1000
    });

    // $('.hero__slider').slick({
    //     arrows: false,
    //     dots: true,
    //     autoplay: true, 
    //     fade: true,
    //     accessibility: false,
    //     pauseOnHover: false
    // });

    $('.gallery-module__wrapper').slick({
        arrows: true,
        dots: true,
        fade: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 5000,
        speed: 1000,
        mobileFirst: true,
        accessibility: true,
        pauseOnHover: false
    });

    $('.slider__slides.start').slick({
        arrows: false,
        dots: true,
        fade: false,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplaySpeed: 5000,
        speed: 700,
        pauseOnHover: false,
        accessibility: true,
        responsive: [
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                fade: true
              }
            }
        ]
    });
    $('.bf-gallery__slider').slick({
        arrows: false, 
        dots: false, 
        autoplay: true, 
        autoplaySpeed: 10000, 
        speed: 500, 
        fade: false, 
        accessibility: false, 
        slidesToShow: 4,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    variableWidth: true
                }
            }
        ]
    });
    
    // FANCYBOXES
    $('.fancybox').fancybox();

    $('.fancybox-module').fancybox({
        maxWidth: 900,
        wrapCSS: 'fancybox-popup__wrapper'
    });

    $(".iframe-virtual-tour").on('click', function(event) {
        event.preventDefault();
        $.fancybox({
            'type' : 'iframe',
            // hide the related video suggestions and autoplay the video
            'href' : this.href.replace(new RegExp('watch\\?v=', 'i'), 'embed/') + '?rel=0&autoplay=1',
            'overlayShow' : true,
            'centerOnScroll' : true,
            'speedIn' : 100,
            'speedOut' : 50,
            'allowfullscreen':true,
            'width'         : '1000px',
            'height'        : '650px',
            'autosize': false,
            'iframe' : {
                preload: false
            }
        });
    });

    // MODULES 
    $('.img-list__item-inner .img-list__item-hover').each(function(){
        var imglistInitialHeight = $(this).find('.img-list__item-title').height();
        $(this).children('.img-list__item-copy').css('height', imglistInitialHeight + 'px');

        $(this).hover(function(){
            var imglistTotalHeight = $(this).find('.img-list__item-title').height() + $(this).find('.img-list__item-reveal').height();

            $(this).children('.img-list__item-copy').css('height', imglistTotalHeight + 'px');
        }, function(){
            var imglistTitleHeight = $(this).find('.img-list__item-title').height();
            $(this).children('.img-list__item-copy').css('height', imglistTitleHeight + 'px');
        });
    });

    $('.accordion__item-trigger').click(function(){
        $(this).toggleClass('active');
        $(this).next('.accordion__item-copy').slideToggle();
    }); 

    //tabs sections
	const tabLinks = document.querySelectorAll('.js-tabs-menu a');

	for (let i = 0; i < tabLinks.length; i++) {
		tabLinks[i].onclick = function() {
			let target = this.getAttribute('href').replace('#', '');
			let sections = document.querySelectorAll('div.tab-content');
			for(let j=0; j < sections.length; j++) {
				sections[j].style.display = 'none';
			}
			document.getElementById(target).style.display = 'block';
			return false;
		}
	}

    window.onload = function () {
        scrollW();
        window.addEventListener('scroll', function () {
            scrollW();
        })
    }
    function scrollW() {
        let st = window.pageYOffset || document.documentElement.scrollTop;
        
        if (st > 0) {
            if (st > lastScrollTop) {
                // downscroll code
                if (!document.getElementById('header').classList.contains('down')) {
                    document.getElementById('header').classList.add('down');
                    document.getElementById('header').classList.remove('up');
                }

            } else {
                // upscroll code
                if (!document.getElementById('header').classList.contains('up')) {
                    document.getElementById('header').classList.add('up');
                    document.getElementById('header').classList.remove('down');
                }
            }

        } else {
            if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
                document.getElementById('header').classList.remove('up');
                document.getElementById('header').classList.remove('down');
            }
            
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }
})();